import { render } from "./EditUserComponent.vue?vue&type=template&id=3ffca5da"
import script from "./EditUserComponent.vue?vue&type=script&lang=js"
export * from "./EditUserComponent.vue?vue&type=script&lang=js"

import "./EditUserComponent.vue?vue&type=style&index=0&id=3ffca5da&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__